var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.965,
    height: 15.965,
    viewBox: "0 0 15.965 15.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculo",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1159",
    "data-name": "Grupo 1159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1683",
    "data-name": "Caminho 1683",
    d: "M8.842,15.013H2.285A2.287,2.287,0,0,1,0,12.728V2.285A2.287,2.287,0,0,1,2.285,0H12.728a2.287,2.287,0,0,1,2.285,2.285V8.842a.326.326,0,0,1-.6.174A3.914,3.914,0,1,0,9.016,14.41a.326.326,0,0,1-.174.6ZM2.285.653A1.634,1.634,0,0,0,.653,2.285V12.728A1.634,1.634,0,0,0,2.285,14.36H7.9A4.567,4.567,0,1,1,14.36,7.9V2.285A1.634,1.634,0,0,0,12.728.653Z",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1684",
    "data-name": "Caminho 1684",
    d: "M14.569,19.138a4.569,4.569,0,1,1,4.569-4.569A4.574,4.574,0,0,1,14.569,19.138Zm0-8.485a3.916,3.916,0,1,0,3.916,3.916A3.92,3.92,0,0,0,14.569,10.653Z",
    transform: "translate(-3.473 -3.473)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1685",
    "data-name": "Caminho 1685",
    d: "M7.243,6.653H3.326a.326.326,0,0,1,0-.653H7.243a.326.326,0,0,1,0,.653Z",
    transform: "translate(-1.042 -2.084)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1686",
    "data-name": "Caminho 1686",
    d: "M6.326,7.569A.326.326,0,0,1,6,7.243V3.326a.326.326,0,0,1,.653,0V7.243A.326.326,0,0,1,6.326,7.569Z",
    transform: "translate(-2.084 -1.042)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1687",
    "data-name": "Caminho 1687",
    d: "M17.59,6.653H14.326a.326.326,0,0,1,0-.653H17.59a.326.326,0,0,1,0,.653Z",
    transform: "translate(-4.862 -2.084)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1688",
    "data-name": "Caminho 1688",
    d: "M6.59,17.917a.328.328,0,0,1-.231-.1L3.1,14.558a.326.326,0,0,1,.461-.461L6.82,17.36a.326.326,0,0,1-.23.557Z",
    transform: "translate(-1.042 -4.862)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1689",
    "data-name": "Caminho 1689",
    d: "M3.326,17.917A.326.326,0,0,1,3.1,17.36L6.359,14.1a.326.326,0,0,1,.461.461L3.557,17.821a.325.325,0,0,1-.23.1Z",
    transform: "translate(-1.042 -4.862)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1690",
    "data-name": "Caminho 1690",
    d: "M17.59,15.653H14.326a.326.326,0,0,1,0-.653H17.59a.326.326,0,0,1,0,.653Z",
    transform: "translate(-4.862 -5.209)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1691",
    "data-name": "Caminho 1691",
    d: "M17.59,18.653H14.326a.326.326,0,0,1,0-.653H17.59a.326.326,0,0,1,0,.653Z",
    transform: "translate(-4.862 -6.251)",
    fill: "#ffbe00",
    stroke: "#ffbe00",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculo);
export default __webpack_public_path__ + "static/media/calculo.723edb3c524a929e86c0cee435735da3.svg";
export { ForwardRef as ReactComponent };